import styled from 'styled-components';

export const ScrollBox = styled.div`
  width: 100%;
  max-height: ${props => `${props.height}`};
  overflow: auto;
`;
